package com.cybersoftsolution.cybersoftsolutionweb.components.buttons

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyFaIcon
import com.cybersoftsolution.cybersoftsolutionweb.components.text.MySpanText
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.ForgetPasswordButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyleDisabled
import com.cybersoftsolution.cybersoftsolutionweb.styles.RegisterButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SecondaryButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SecondaryButtonStyleDisabled
import com.cybersoftsolution.cybersoftsolutionweb.styles.Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.registerButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.cybersoftsolution.cybersoftsolutionweb.utils.Utils.darker
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.disabled
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.VerticalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.ms

import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button

@Composable
    fun MyButtonNew(
    style: CssStyle<GeneralKind>? = null,
    modifier: Modifier = Modifier,
    borderRadius: CSSSizeValue<CSSUnit.px> = 15.px,
    faIconsClassName: Resources.FaIconsClassName?=null,
    image: (@Composable () -> Unit)? = null,
    id: String,
    text: String?=null,
    textColor: CSSColorValue = Theme.Withe.rgb,
    fontSize:Int = 16,
    enabled: Boolean = true,
    onClick: () -> Unit = {}
    ){

    val styleModifier = style?.toModifier() ?: Modifier

    Button(
        attrs = styleModifier
            .id(id)
            .borderRadius(borderRadius)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .disabled(!enabled)
            .cursor(Cursor.Pointer)
                    .thenIf(
                        condition = !enabled,
                        other = Modifier.cursor(Cursor.Default)
                    )
            .onClick {
                onClick()
            }

            .flexShrink(1) // Allow the button to shrink within the Row
            .overflow(Overflow.Hidden) // Hide any potential overflow from the button itself
            .then(modifier)
            .toAttrs(),
    ){
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
            modifier = Modifier
                .height(100.percent)
                .fillMaxWidth()
        ) {
            if (image != null) {
                image()
                VerticalDivider()
            }
            faIconsClassName?.let {
                MyFaIcon(
                    modifier = Modifier
                        .color(textColor)
                        .margin(left = 10.px),
                    faIconsClassName = it
                )
                VerticalDivider()
            }
            SpanText(
                modifier = Modifier
                    .margin(leftRight = 10.px)
                    .color(textColor)
                    .fontSize(fontSize.px)
                ,
                text = text.orEmpty(),
            )
        }

    }

    }



